import type { AppState } from 'state/model';
import { getAccountNameLength } from 'state/userPreferences/selectors';
import type { Client } from 'state/referenceData/referenceDataModel';

export function getClientName(state: AppState, client: Client) {
  return getAccountNameLength(state) === 'Short' && client.externalCompanyName
    ? client.externalCompanyName
    : client.companyName;
}
